import script from "./RepairTag.vue?vue&type=script&setup=true&lang=js"
export * from "./RepairTag.vue?vue&type=script&setup=true&lang=js"

import "./RepairTag.vue?vue&type=style&index=0&id=a0068c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0068c20"]])

export default __exports__